import { MatchStatuses } from "@finbackoffice/fe-core";
import { useMemo } from "react";
import { IScoreboardResponse } from "@finbackoffice/websocket-client";

type Turn = "ball" | "bat";

const TEAM1_BATTING_MATCH_STATUS_IDS = [
    MatchStatuses.CRICKET_HOME_TEAM_BATTING,
    MatchStatuses.CRICKET_HOME_TEAM_BATTING_2,
];

const TEAM2_BATTING_MATCH_STATUS_IDS = [
    MatchStatuses.CRICKET_AWAY_TEAM_BATTING,
    MatchStatuses.CRICKET_AWAY_TEAM_BATTING_2,
];

export const useCricketMatchStatus = (
    matchStatus: string,
    matchStatusId: number | null,
    scoreboard: IScoreboardResponse | null,
) => {
    const team1Turn: Turn = useMemo(
        () =>
            matchStatusId !== null && [...TEAM1_BATTING_MATCH_STATUS_IDS].includes(matchStatusId)
                ? "bat"
                : "ball",
        [matchStatusId],
    );

    const team2Turn: Turn = useMemo(
        () =>
            matchStatusId !== null && [...TEAM2_BATTING_MATCH_STATUS_IDS].includes(matchStatusId)
                ? "bat"
                : "ball",
        [matchStatusId],
    );

    const cricketMatchStatus = useMemo(() => {
        const isUnknownMatchStatus =
            matchStatusId !== null &&
            ![...TEAM1_BATTING_MATCH_STATUS_IDS, ...TEAM2_BATTING_MATCH_STATUS_IDS].includes(
                matchStatusId,
            );

        return isUnknownMatchStatus
            ? matchStatus
            : `INN ${scoreboard?.innings} | ${scoreboard?.over}.${scoreboard?.delivery}`;
    }, [matchStatus, matchStatusId, scoreboard?.delivery, scoreboard?.innings, scoreboard?.over]);

    return { team1Turn, team2Turn, cricketMatchStatus };
};
